/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { AlertMessageComponent } from '@shared/alert-message/alert-message.component';
import { ReadOnlyWithoutPermissionDirective } from '@shared/directives/read-only-without-permission.directive';
import { NoResultMessageComponent } from '@shared/no-result-message/no-result-message.component';
import { AbsenceClassPipe } from '@shared/pipes/absence-class.pipe';
import { LicenseClassPipe } from '@shared/pipes/license-class.pipe';
import { ObjectIdPipe } from '@shared/pipes/object-id.pipe';
import { TrustLinkPipe } from '@shared/pipes/trust-link.pipe';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  declarations: [
    ObjectIdPipe,
    AbsenceClassPipe,
    LicenseClassPipe,
    TrustLinkPipe,
    AlertMessageComponent,
    NoResultMessageComponent,
    ReadOnlyWithoutPermissionDirective
  ],
  imports: [
    NgxPermissionsModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSidenavModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    ScrollingModule,
    RouterModule,
    MatListModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatSliderModule,
    MatSortModule,
  ],
  exports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatCheckboxModule,
    MatDividerModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSidenavModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    ScrollingModule,
    RouterModule,
    ObjectIdPipe,
    AbsenceClassPipe,
    TrustLinkPipe,
    MatListModule,
    LicenseClassPipe,
    MatTooltipModule,
    AlertMessageComponent,
    MatProgressBarModule,
    NoResultMessageComponent,
    MatExpansionModule,
    MatSliderModule,
    MatSortModule,
    NgxPermissionsModule,
    ReadOnlyWithoutPermissionDirective,
  ],
  providers: [
    DatePipe,
    ObjectIdPipe,
    TrustLinkPipe,
  ]
})
export class SharedModule { }
